export default __webpack_public_path__ + "static/media/games.93be206e.png";